import React from "react"
import { CREATE_WEB_USER } from '../../../requests'
import { MASK, VALIDATE } from 'components/Wizard2/validate'
import AddressBlock from "../../Wizard2/fieldComponents/AddressBlock"
import { getAddressObject } from 'components/Wizard2/WizardClasses'

export default class CreateAccountForm extends React.Component {
  state = {
    errors: {},
    address: process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? getAddressObject() : null
  }
  checkEnter = e => {
    if (e.charCode === 13) {
      this.validate()
    }
  }
  validate = async () => {
    const account = {
      firstName: this.firstName.value,
      middleName: this.middleName.value,
      lastName: this.lastName.value,
      orgName: process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ? this.orgName.value : "",
      username: process.env.SHOW_USERNAME_ACCOUNT_CREATE ? this.username.value : '',
      email: this.email.value || '',
      phone: process.env.HIDE_PHONE_ACCOUNT_CREATE ? '' : this.phone.value,
      address: process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? this.state.address : '',
      password: this.password.value,
      confirmPassword: this.confirmPassword.value
    }
    let errors = {}
    if (!account.firstName) {
      errors.firstName = "First name is required"
    }
    if (!account.lastName) {
      errors.lastName = "Last name is required"
    }
    if (!account.username && process.env.SHOW_USERNAME_ACCOUNT_CREATE) {
      errors.username = "User name is required"
    }
    if (!account.email && !process.env.SHOW_USERNAME_ACCOUNT_CREATE) {
      errors.email = "An email is required"
    } else if (account.email.split('@').length !== 2 || account.email.split('.').length < 2) {
      errors.email = "Must be a properly formatted email"
    }
    if (!process.env.HIDE_PHONE_ACCOUNT_CREATE && !process.env.PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE && (!account.phone || !await new Promise((resolve) => VALIDATE.validPhoneNumber(account.phone, {}, {}, (isValid) => resolve(isValid))))) {
      errors.phone = "A phone number is required"
    }
    if (!account.password) {
      errors.password = "A password is required"
    } else if (account.password.length < 8) {
      errors.password = process.env.PASSWORD_CUSTOM_ERROR_TEXT || "Password must be at least 8 characters"
    }
    if (account.password !== account.confirmPassword) {
      errors.confirmPassword = "Passwords must match"
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors })
    } else {
      this.setState({ errors: {} })
      this.createAccount(account)
    }
  }
  toLowercaseKeys = (obj) => (
    Object.keys(obj).reduce((newObj, key) => {
      newObj[key.toLowerCase()] = obj[key];
      return newObj;
    }, {})
  )
  createAccount = account => {
    account = process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? {...account, ...this.toLowercaseKeys(this.state.address)} : account
    delete account.address
    console.log(account)
    CREATE_WEB_USER(account, userId => {
      this.props.returnToLogin({
        type: "success",
        message: process.env.ACCOUNT_CREATED_MESSAGE || "Your account was successfully created. Please login below."
      })
    }, err => {
      this.setState({
        errors: {
          global: err.message || "Something went wrong, try again later"
        }
      })
    })
  }  
  setValue = (value, key) => {
    this.setState(state => ({
      ...state,
      [key]: value
    }
   ))
  }
  render() {
    const { returnToLogin } = this.props;
    return (
      <form className="wizard login create-account">
        <div className={`${process.env.TWO_COLUMN_ACCOUNT_CREATE ? 'column-1' : ''}`}>
        <div className='name-wrapper'>
          <div className="field">
            <label htmlFor="firstName" id="firstName-label">First name{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="text"
              ref={ref => {
                this.firstName = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder="John"
              id="firstName"
              aria-describedby="firstName-error"
              aria-invalid={!!this.state.errors.firstName}
              aria-labelledby="firstName-label"
            />
            <FieldError id="firstName-error">{this.state.errors.firstName}</FieldError>
          </div>
          <div className="field">
            <label htmlFor="middleName" id="middleName-label">Middle name</label>
            <input
              type="text"
              ref={ref => {
                this.middleName = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder="Paul"
              id="middleName"
              aria-describedby="middleName-error"
              aria-labelledby="middleName-label"
            />
          </div>
          <div className="field">
            <label htmlFor="lastName" id="lastName-label">Last name{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="text"
              ref={ref => {
                this.lastName = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder="Doe"
              id="lastName"
              aria-describedby="lastName-error"
              aria-invalid={!!this.state.errors.lastName}
              aria-labelledby="lastName-label"
            />
            <FieldError id="lastName-error">{this.state.errors.lastName}</FieldError>
          </div>
        </div>
        {
          process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ?
            <div className="field">
              <label htmlFor="orgName" id="orgName-label">Organization name</label>
              <input
                type="text"
                ref={ref => {
                  this.orgName = ref
                }}
                onKeyDown={this.checkEnter}
                placeholder="Your LLC"
                id="orgName"
                aria-labelledby="orgName-label"
              />
            </div>
            :
            null
        }
        {
          process.env.SHOW_USERNAME_ACCOUNT_CREATE ?
            <div className="field">
              <label htmlFor="username" id="username-label">Username{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
              <input
                type="text"
                ref={ref => {
                  this.username = ref
                }}
                onKeyDown={this.checkEnter}
                placeholder="username"
                id="username"
                aria-labelledby="username-label"
              />
            </div>
            :
            null
        }
        <div className="field">
          <label htmlFor="email" id="email-label">Email{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
          <input
            type="text"
            ref={ref => {
              this.email = ref
            }}
            onKeyDown={this.checkEnter}
            placeholder="example@email.com"
            id="email"
            aria-describedby="email-error"
            aria-invalid={!!this.state.errors.email}
            aria-labelledby="email-label"
          />
          <FieldError id="email-error">{this.state.errors.email}</FieldError>
        </div>
        {process.env.HIDE_PHONE_ACCOUNT_CREATE ? 
          null
          :
          <div className="field">
            <label htmlFor="phone" id="phone-label">Phone</label>
            <input
              type="text"
              autoComplete="tel"
              onChange={(e) => this.phone.value = MASK.phone(e.target.value)}
              ref={ref => {
                this.phone = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder="###-###-####"
              id="phone"
              aria-describedby="phone-error"
              aria-invalid={!!this.state.errors.phone}
              aria-labelledby="phone-label"
            />
            <FieldError id="phone-error">{this.state.errors.phone}</FieldError>
          </div>
        }
        {process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? 
          <div className="wizard">
            <AddressBlock
              value={this.state.address}
              onChange={value => {this.setValue(value, 'address')}}
              width='100%'
              showCityStateZip
              allowSelection={false}
              singleColSize='col-12'
              showCountry={true}
              hideAttention={true}
              triColSizes={{
                CITY: 'col-4',
                STATE: 'col-4',
                POSTAL_CODE: 'col-4',
                ZIP: 'col-4'
              }}
            />
            <FieldError id="address-error">{this.state.errors.address}</FieldError>
          </div>  
          :
          null
        }
        </div>
        <div className={`${process.env.TWO_COLUMN_ACCOUNT_CREATE ? 'column-2' : ''}`}>
          <div className="field">
            <label htmlFor="password-field" id="password-label">Password{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
            <span className='description' id="password-description">
              {process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE ? 
                <span dangerouslySetInnerHTML={{__html: process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE}}></span>
              : 
                'Must be at least 8 characters'
              }
            </span>
            <input
              type="password"
              ref={ref => {
                this.password = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder=""
              id="password-field"
              aria-describedby="password-description . password-error"
              aria-invalid={!!this.state.errors.password}
              aria-labelledby="password-label"
            />
            <FieldError id="password-error">{this.state.errors.password}</FieldError>
          </div>
          <div className="field">
            <label htmlFor="confirm-password" id="confirm-label">Confirm Password{process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="password"
              ref={ref => {
                this.confirmPassword = ref
              }}
              onKeyDown={this.checkEnter}
              placeholder=""
              id="confirm-password"
              aria-describedby="confirm-error"
              aria-invalid={!!this.state.errors.confirmPassword}
              aria-labelledby="confirm-label"
            />
            <FieldError id="confirm-error">{this.state.errors.confirmPassword}</FieldError>
          </div>
          <div className="button-wrapper create-wrapper">
            <button
              type="button"
              className="btn-raised btn-light-primary submit"
              onClick={this.validate}
            >
              CREATE ACCOUNT
            </button>
            <FieldError role="alert">{this.state.errors.global}</FieldError>
          </div>
          <div className="button-wrapper create-wrapper">
            <button
              type="button"
              className="create-account-button"
              onClick={returnToLogin}
            >
              Login with existing account
            </button>
          </div>
        </div>
      </form>
    )
  }
}

export const FieldError = ({ children, id="", role }) => (
  children ? <p className="field-error animated fadeIn fast-animation" id={id} role={role}>{children}</p> : null
)



// WEBPACK FOOTER //
// ./src/components/Shell/Login/CreateAccount.js